<template>
  <div id="vanber">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>岗位管理</el-breadcrumb-item>
      <el-breadcrumb-item>岗位发布</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="职位名称" prop="job_name">
            <el-input v-model="form.job_name" placeholder="请输入职位名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="职位类型" prop="job_type">
            <el-select v-model="form.job_type" placeholder="请选择职位类型">
              <el-option
                v-for="item in jobType"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="薪资待遇" prop="salary">
            <el-select v-model="form.salary_start" placeholder="最低薪资" class="w">
              <el-option
                v-for="item in salaryList"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select v-model="form.salary_end" placeholder="最高薪资" class="w">
              <el-option
                v-for="item in salaryList"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="食宿安排">
            <el-select v-model="form.food_bed" placeholder="选择食宿安排">
              <el-option
                v-for="item in foodList"
                :key="item.id"
                :label="item.value"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="年龄要求">
            <el-select v-model="form.age_require">
              <el-option label="不限" value="不限"></el-option>
              <el-option label="18岁以上" value="18岁以上"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学历要求" prop="education">
            <el-select v-model="form.education" placeholder="请选择学历要求">
              <el-option
                v-for="item in educationList"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="招聘人数" prop="recruitment">
            <el-input v-model="form.recruitment" placeholder="请输入人数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工作城市" prop="city_id">
            <el-select placeholder="省" v-model="form.province_id" @change="provChange" class="w">
              <el-option
                v-for="item in $store.state.provinces"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select placeholder="市" v-model="form.city_id" ref="city" class="w">
              <el-option
                v-for="item in cityList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="工作地点" prop="job_address">
            <el-input v-model="form.job_address" placeholder="请输入详细地址"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="截止时间">
            <!-- <el-date-picker v-model="form.end_time" type="date" placeholder="选择日期"></el-date-picker> -->
            <el-date-picker
              v-model="form.end_time"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期时间"
              class="w100"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="职位诱惑" prop="job_attraction">
        <el-input v-model="form.job_attraction" placeholder="请输入岗位亮点"></el-input>
      </el-form-item>

      <el-form-item label="职位描述">
        <div id="wangeditor">
          <div ref="editorElem" class="wa" style="text-align:left;"></div>
        </div>
      </el-form-item>

      <el-row class="btn">
        <el-button type="primary" @click="onSubmit('form')">确认发布</el-button>
      </el-row>
    </el-form>

    <!-- <el-dialog title="提示" :visible.sync="tip" width="30%">
      <span style="font-size: 20px;line-height: 1.5;">发布平台岗位成功后需要支付{{jobFee}}元，否则学生看不到此岗位</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tip = false">确 定</el-button>
      </span>
    </el-dialog>-->

    <!-- 选择发布时长弹出框 -->
    <el-dialog title="请进行岗位发布认证" :visible.sync="dialogFormVisible" width="500px">
      <div class="infoText">当前岗位发布需认证付费，请选择您要发布的岗位有效月份数，并完成付费认证，即可开启招聘！付费后您的岗位排名TOP10%！</div>
      <el-form>
        <el-radio v-model="monthRadio" :label="payInfo[0].code">{{payInfo[0].value}}元/1个月</el-radio>
        <el-radio v-model="monthRadio" :label="payInfo[1].code">{{payInfo[1].value}}元/2个月</el-radio>
        <el-radio v-model="monthRadio" :label="payInfo[2].code">{{payInfo[2].value}}元/3个月</el-radio>
      </el-form>
      <div class="red">平台建议：岗位有效期越久排名越靠前，平台投递人数会更多</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="toPlatformList()">取 消</el-button>
        <el-button type="primary" @click="chooseMonth()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import E from "wangeditor";
import axios from "axios";
import baseUrl from "@/api/baseUrl.js";
import qs from "qs";
import formatter from "@/assets/js/mixins/formatter";
import { tarsformHtml } from "@/assets/js/common.js";


export default {
  mixins: [formatter],
  name: "Editor",
  data() {
    let checkProvAndCity = (rule, value, callback) => {
      if (!value) {
        callback(new Error("省市必填"));
      } else if (!this.$refs.city.value) {
        callback(new Error("市级必填"));
      } else {
        callback();
      }
    };
    return {
      cityList: [],
      salaryList: [], // 岗位待遇
      foodList: [], //食宿安排情况
      jobType: [], //岗位类型
      educationList: [], // 学历类型
      // 验证规则
      rules: {
        job_name: [{ required: true, message: "请输入岗位", trigger: "blur" }],
        city_id: [
          {
            required: true,
            validator: checkProvAndCity,
            trigger: ["blur", "change"]
          }
        ],
        job_address: [
          { required: true, message: "请输入岗位详细地址", trigger: "blur" }
        ],
        job_type: [
          {
            required: true,
            message: "请选择岗位类型",
            trigger: ["blur", "change"]
          }
        ],
        education: [
          {
            required: true,
            message: "请选择学历要求",
            trigger: ["blur", "change"]
          }
        ],
        job_detail: [
          { required: true, message: "请输入岗位描述", trigger: "blur" }
        ],
        job_attraction: [
          { required: true, message: "请输入岗位吸引力", trigger: "blur" }
        ],
        request: [
          { required: true, message: "请输入岗位要求", trigger: "blur" }
        ],
        recruitment: [
          {
            required: true,
            message: "请输入招聘人数",
            trigger: "blur"
          }
        ],
        salary: [{ required: true, message: "请选择岗位待遇" }],
        expect_start: [
          {
            type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        expect_end: [
          {
            type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ]
      },
      form: {
        school_id: "",
        // id: localStorage.getItem("token"),
        job_name: "", //岗位
        province_id: null,
        city_id: null,
        province: null,
        city: null,
        age_require: "",
        contact: "", //联系人
        email: "", //email
        telephone: "", //联系人电话
        job_address: "", //岗位详细地址
        job_detail: "", //岗位描述
        job_attraction: "", //岗位吸引力
        request: "", //岗位要求
        remark: "", //备注
        recruitment: "100", //招聘人数
        salary_start: "",
        salary_end: "",
        salary: "", //岗位待遇
        expect_start: "", //到岗时间
        expect_end: "", //过期时间
        food_bed: "", //食宿安排情况
        expect_major: "", //对口专业
        end_time: "", //截止时间
        job_type: "", // 岗位类型
        education: "" // 学历要求
        // job_attraction: '' // 岗位诱惑
      },
      // tip: true,
      operate: this.$route.query.operate, // 操作类型（添加：add，修改：update）
      jobFee: "",
      editor: null,
      editorContent: "",
      dialogFormVisible: false,
      pay_jobId: "",
      monthRadio: "",
      payInfo: [
        { code: 0, value: 0 },
        { code: 0, value: 0 },
        { code: 0, value: 0 }
      ]
    };
  },
  // catchData是一个类似回调函数，来自父组件，当然也可以自己写一个函数，主要是用来获取富文本编辑器中的html内容用来传递给服务端
  watch: {
    "form.recruitment"(newVal) {
      if (!/^[1-9]\d*$/.test(newVal)) {
        this.$message.error("请输入纯数字！");
        this.form.recruitment = "";
      }
    },
    "form.salary_start"(val) {
      if (val) {
        if (this.form.salary_end) {
          this.form.salary = `${val} ~ ${this.form.salary_end}`;
        } else {
          this.form.salary = `${val}`;
        }
      }
    },
    "form.salary_end"(val) {
      if (val && this.form.salary_start) {
        this.form.salary = `${this.form.salary_start} ~ ${val}`;
      }
    },
    "form.province_id"(val) {
      if (val) {
        this.form.province = this.formatProv(val);
      }
    },
    "form.city_id"(val) {
      if (val) {
        this.form.city = this.formatCity(this.cityList, val);
      }
    }
  },
  // created() {
  //   this.operate === "update" ? (this.tip = false) : "";
  // },
  mounted() {
    // 富文本
    this.editor = new E(this.$refs.editorElem);
    // 编辑器的事件，每次改变会获取其html内容
    this.editor.customConfig.onchange = html => {
      this.editorContent = html;
      this.catchData(this.editorContent); // 把这个html通过catchData的方法传入父组件
    };
    this.editor.customConfig.menus = [
      // 菜单配置
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "strikeThrough", // 删除线
      "foreColor", // 文字颜色
      // "backColor", // 背景颜色
      // "link", // 插入链接
      // "list", // 列表
      "justify", // 对齐方式
      // "quote", // 引用
      // "emoticon", // 表情
      // "image", // 插入图片
      // "table", // 表格
      // "code", // 插入代码
      "undo", // 撤销
      "redo" // 重复
    ];
    this.editor.create(); // 创建富文本实例

    this.getPayInfo();
    this.getOption();
    if (this.$route.query.operate === "update") {
      let job = JSON.parse(localStorage.getItem("job"));
      if (job.province_id) {
        this.getXixunCity(job.province_id);
      }
      for (let key in this.form) {
        this.form[key] = job[key];
      }
      // this.form.food_bed = job.food_bed;
      this.editor.txt.html(tarsformHtml(this.form.job_detail));
    }
  },
  methods: {
    async getXixunCity(provinceId) {
      let res = await this.$api.common.getXixunCity(provinceId);
      if (res.code === 0) {
        this.cityList = res.data;
      }
    },
    provChange(provId) {
      this.cityList = null;
      this.form.city_id = null;
      this.getXixunCity(provId);
    },
    async getOption() {
      let salary = await this.$api.common.getSalaryList();
      if (salary.code === 0) {
        this.salaryList = salary.data;
      }
      let food = await this.$api.common.getTypeList("food_bed");
      if (food.code === 0) {
        this.foodList = food.data;
      }
      let type = await this.$api.common.getJobType();
      if (type.code === 0) {
        this.jobType = type.data;
      }
      let education = await this.$api.common.getEducationList();
      if (education.code === 0) {
        this.educationList = education.data;
      }
    },
    onSubmit(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          // console.log(this.editor.txt.text());
          // console.log(this.editor.txt.html());
          this.form.job_detail = this.editor.txt.text();
          // this.form.job_detail = this.editor.txt.html();
          // this.form.school_id = this.$route.query.schoolId;
          // return;
          this.jobAdd();
        } else {
          return false;
        }
      });
    },
    async jobAdd() {
      let res = null;
      if (this.$route.query.operate === "add") {
        let params = this.delNullVal(this.form);
        res = await this.$api.job.addPlatformJob(params);
      } else if (this.$route.query.operate === "update") {
        let job = JSON.parse(localStorage.getItem("job"));
        let params = this.delNullVal(this.form);
        res = await this.$api.job.updatePlatformJob(job.id, params);
      }

      if (res.code === 0) {
        let jobId = res.data.id;
        this.pay_jobId = jobId;
        if (this.$route.query.operate === "add") {
          // 判断是否需要跳转付费界面
          let requirePay = res.data.requirePay;
          // if (requirePay == "yes") {
          //   // 显示选择发布时长并跳转付费页面对话框
          //   this.dialogFormVisible = true;
          // } else if (requirePay == "no") {
            this.$confirm("岗位发布成功，联系管理员快速审核", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "success"
            })
              .then(() => {
                this.$router.push({
                  path: "/platformJobList"
                });
              })
              .catch(() => {
                this.$router.push({
                  path: "/platformJobList"
                });
              });
          // }

          // this.dialogFormVisible = true;
        } else if (this.$route.query.operate === "update") {
          this.$message({
            message: "编辑成功!",
            type: "success",
            center: true
          });
          this.$router.go(-1);
        }
      }
    },
    async getPayInfo() {
      let res = await this.$api.pay.getPlatformJobFee();
      this.payInfo = res.data;
    },
    chooseMonth() {
      this.dialogFormVisible = false;
      this.payJobFee(this.pay_jobId, this.monthRadio);
    },
    toPlatformList() {
      this.dialogFormVisible = false;

      this.$router.push({
        path: "/platformJobList"
      });
    },
    payJobFee(jobId, month) {
      let params = {
        subject: "平台岗位服务费",
        type: "web",
        // school_id: this.$route.query.schoolId,
        job_id: jobId,
        fee_type: month
      };
      axios
        .post(
          baseUrl + "api/enterprise/pay/xcx_job/alipay/index",
          qs.stringify(params),
          {
            withCredentials: true
          }
        )
        .then(res => {
          if (res.data.code && res.data.code !== 0) {
            this.$message.error(res.data.msg);
            return;
          }
          const div = document.createElement("div");
          div.innerHTML = res.data;
          document.body.appendChild(div);
          document.forms[2].acceptCharset = "GBK"; //保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
          document.forms[2].submit();
        });
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .w-e-toolbar .w-e-menu {
  z-index: 10 !important;
}
/deep/ .w-e-text-container {
  position: relative;
  z-index: 10 !important;
}

#vanber {
  position: relative;
  padding: 20px;

  .el-form {
    width: 900px;
    margin: 40px 0 0 40px;

    .el-row {
      margin-bottom: 0px;
    }

    .btn {
      padding-left: 50px;
      text-align: center;
      padding-top: 30px;
      .el-button {
        width: 286px;
      }
    }
    .el-select {
      width: 100%;
    }
    .w {
      width: 50%;
    }
    .w100 {
      width: 100%;
    }
  }

  /deep/ .el-dialog {
    .el-dialog__body {
      padding: 5px 20px;
      .el-form{
        margin: 0;
      }
      .infoText {
        color: orange;
        margin-bottom: 20px;
      }
      .red {
        color: red;
        margin-top: 20px;
      }
    }
  }
}
</style>
